import React from 'react';
import Styles from './styles.module.scss';
import cx from 'classnames';

export class SecondPinkButton extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <button
        className={cx(
          Styles['circle-pink-button'],
          this.props.checked && Styles['checked']
        )}
        type="click"
        onClick={this.props.onClick}
      >
        {this.props.children}
      </button>
    );
  }
}
